import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CalendarIcon, TrendingUpIcon, ShieldCheckIcon } from 'lucide-react';
export function CredibilitySection() {
  return <section className="py-10 relative overflow-hidden bg-background" data-id="element-44">
      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-45">
        <FadeIn data-id="element-46">
          <div className="bg-gradient-to-br from-primary/10 via-card to-background border border-primary/20 rounded-3xl p-6 md:p-10 shadow-2xl relative overflow-hidden" data-id="element-47">
            {/* Decorative elements */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-primary/10 rounded-full blur-3xl pointer-events-none" data-id="element-48" />
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-secondary/10 rounded-full blur-3xl pointer-events-none" data-id="element-49" />

            <div className="text-center mb-8 relative z-10" data-id="element-50">
              <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/20 text-primary mb-6" data-id="element-51">
                <CalendarIcon className="w-8 h-8" data-id="element-52" />
              </div>
              <h2 className="text-3xl md:text-4xl font-black mb-4 text-gray-900" data-id="element-53">
                Lo que cambia en{' '}
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary" data-id="element-54">
                  7 días
                </span>
              </h2>
              <p className="text-xl text-primary font-medium" data-id="element-55">
                Prueba de Credibilidad
              </p>
            </div>

            <div className="space-y-6 relative z-10" data-id="element-56">
              <div className="flex items-start gap-5 bg-white/60 p-5 rounded-2xl border border-card-border" data-id="element-57">
                <TrendingUpIcon className="w-8 h-8 text-green-500 shrink-0 mt-1" data-id="element-58" />
                <div data-id="element-59">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-60">
                    Estructura Inmediata
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-61">
                    En la primera semana de usar la Base Técnica, vas a notar
                    cómo tus clases ganan estructura.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-5 bg-white/60 p-5 rounded-2xl border border-card-border" data-id="element-62">
                <ShieldCheckIcon className="w-8 h-8 text-primary shrink-0 mt-1" data-id="element-63" />
                <div data-id="element-64">
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-65">
                    Confianza Total
                  </h3>
                  <p className="text-gray-600 leading-relaxed" data-id="element-66">
                    Tus alumnos empiezan a confiar más en cada elección. Y vos
                    sentís la tranquilidad de tener una respuesta profesional
                    inmediata.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}